import { Button } from "src/@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select"
import { Checkbox } from "src/@/components/ui/checkbox"
import { RowInput } from "src/components/forms/RowInput"
import { Label } from "src/@/components/ui/label"
import { Plus, X } from "lucide-react"
import { useState } from "react"

export default function ModalCustomField({
  open,
  onClose,
  onSubmit,
  action,
  nome,
  changeNome,
  tipo,
  changeTipo,
  opcoes,
  changeOpcoes,
  obrigatorio,
  changeObrigatorio
}) {
  const [novaOpcao, setNovaOpcao] = useState('');

  const adicionarOpcao = () => {
    if (novaOpcao.trim()) {
      changeOpcoes([...(opcoes || []), novaOpcao.trim()]);
      setNovaOpcao('');
    }
  };

  const removerOpcao = (index) => {
    changeOpcoes(opcoes.filter((_, i) => i !== index));
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {action === "Criar" ? "Criar campo personalizado" : "Editar campo personalizado"}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RowInput
            label="Nome do campo"
            input={<Input
              onChange={changeNome}
              value={nome}
              placeholder="Ex: Número da cotação"
            />}
          />
          <RowInput
            label="Tipo"
            input={
              <Select value={tipo} onValueChange={changeTipo}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Selecione o tipo" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="texto">Texto</SelectItem>
                  <SelectItem value="selecao">Seleção</SelectItem>
                  <SelectItem value="data">Data</SelectItem>
                  <SelectItem value="upload">Upload de arquivo</SelectItem>
                </SelectContent>
              </Select>
            }
          />

          {tipo === "selecao" && (
            <div className="space-y-2">
              <Label className="text-sm font-medium text-gray-700">Opções</Label>
              <div className="space-y-1.5">
                {opcoes?.map((opcao, index) => (
                  <div key={index} className="flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-200">
                    <span className="text-sm flex-1">{opcao}</span>
                    <button
                      onClick={() => removerOpcao(index)}
                      className="text-gray-400 hover:text-red-500 transition-colors"
                    >
                      <X size={14} />
                    </button>
                  </div>
                ))}
              </div>
              <div className="flex gap-2">
                <Input
                  value={novaOpcao}
                  onChange={(e) => setNovaOpcao(e.target.value)}
                  placeholder="Nova opção"
                  onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), adicionarOpcao())}
                  className="flex-1"
                />
                <Button variant="outline" size="sm" onClick={adicionarOpcao}>
                  <Plus size={14} />
                </Button>
              </div>
            </div>
          )}

          <div className="flex items-center space-x-2">
            <Checkbox
              checked={obrigatorio}
              onCheckedChange={changeObrigatorio}
            />
            <Label className="text-sm text-gray-600">Campo obrigatório</Label>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onSubmit}>{action === "Criar" ? "Criar" : "Salvar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
